// shared/domain/usuario.js  (reglas puras sobre usuarios; el catálogo solo trae { id, nombre })

/** Nombre del usuario por id; si no se pudo cargar el catálogo (p. ej. 403) => "Usuario {id}". Sin id => ''. */
export const nombreUsuario = (usuarios = [], id) => {
  if (id === null || id === undefined || id === '') return '';
  const found = usuarios.find(u => u.id === Number(id));
  return found && found.nombre ? found.nombre : `Usuario ${id}`;
};
